import React, { useState } from "react";
import {
  CustomButton2,
  CustomIcon,
  CustomInput,
  CustomModal,
} from "../../../../components";
import Context from "../../../../context";

import "./index.scss";
import SelectArea from "./SelectArea";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Row } from "react-bootstrap";
import Column from "../../../../components/CustomView/Column";
import CustomDropDownSearch from "../../../../components/CustomDropDownSearch";
import { useQuery } from "react-query";
import values from "../../../../values";
import api from "../../../../api";
import { IProvinceCity } from "../../../../types/area.interface";

const Create = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createArea, loading } = React.useContext(
    Context.AreaScreen
  );

  const [selectedArea, setSelectedArea] = useState<
    { lat: number; lng: number }[] | undefined
  >(undefined);
  const [areaName, setAreaName] = useState<string>("");
  const [errors, setErrors] = useState<{ area: string }>({ area: "" });
  const [selectedProvince, setSelectedProvince] = useState<IProvinceCity>();
  const [selectedCity, setSelectedCity] = useState<IProvinceCity>();

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("فیلد نام منطقه اجباری است")
        .min(2, "حداقل دو حرف وارد کنید"),
    }),
    onSubmit: async (values) => {
      const coords = selectedArea?.map((item) => [item.lat, item.lng]);
      console.log({ ...values, coords });
      if (selectedArea !== undefined) {
        const result = await createArea!({
          ...values,
          coords,
          county: selectedCity?._id,
        });
        result && formik.resetForm();
        result && setSelectedArea(undefined);
      }
    },
  });

  const onSubmit = () => {
    if (selectedArea === undefined) {
      setErrors({ area: "محدوده مورد نظر را انتخاب کنید" });
    }
    formik.submitForm();
  };

  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.getMethod.common.findProvinceCity({})
  );

  const getAllCity = useQuery(
    [values.useQueryKeys.getAllProvince, selectedProvince],
    () =>
      api.getMethod.common.findProvinceCity({
        provinceId: selectedProvince?._id,
      })
  );

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="create-update-area-modal-container">
      <CustomIcon icon="fa fa-add" onClick={() => setShowModal!("CREATE")} />
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "CREATE"}
        minWidth={"60rem"}
        // minHeight={"60vh"}
      >
        <form onSubmit={onSubmit}>
          <Row>
            <Column medium={4}>
              <CustomDropDownSearch
                items={getAllProvince?.data?.result}
                itemName="title"
                onSelectItem={(event) => {
                  setSelectedProvince(event);
                  setSelectedCity(undefined);
                }}
                placeHolder="انتخاب استان"
                label="استان"
                defaultItem={selectedProvince}
                isSearch
              />
            </Column>
            <Column medium={4}>
              <CustomDropDownSearch
                items={getAllCity?.data?.result}
                itemName="title"
                onSelectItem={(event) => setSelectedCity(event)}
                placeHolder="انتخاب شهر"
                label="شهر"
                defaultItem={selectedCity}
                isSearch
              />
            </Column>
            <Column medium={4}>
              <CustomInput
                name="name"
                label={"نام منطقه"}
                id="name"
                value={formik?.values?.name}
                onValueChange={formik?.handleChange}
                onBlur={formik?.handleBlur}
                error={formik.errors.name && formik.errors.name}
                errorText={formik.errors.name}
              />
            </Column>
          </Row>

          <Row>
            <Column className="dropdown">
              <SelectArea
                setAreaState={setSelectedArea}
                areaState={selectedArea as { lat: number; lng: number }[]}
                zoom={selectedCity ? 12 : selectedProvince ? 8 : 6}
                defaultAreaLatLng={
                  selectedCity
                    ? [
                        selectedCity?.latitude as number,
                        selectedCity?.longitude as number,
                      ]
                    : selectedProvince
                    ? [
                        selectedProvince?.latitude as number,
                        selectedProvince?.longitude as number,
                      ]
                    : [32, 53]
                }
              />
              <div className="error">{errors?.area !== "" && errors?.area}</div>
            </Column>
          </Row>
          <Row>
            <Column medium={4}>{""}</Column>
            <Column medium={4}>
              <CustomButton2
                type="primary"
                onClick={onSubmit}
                title={"ثبت منطقه"}
                isLoading={loading}
              />
            </Column>
            <Column medium={4}>{""}</Column>
          </Row>
        </form>
      </CustomModal>
    </section>
  );
};

export default Create;
